<template>
  <div class="div" v-if="generatedReport">
    <div class="form border">
      <div class="row p-3">
        <a-spin :spinning="status === 'generating'" v-if="generatedReport">
          <div class="report-header">
            Budget (Start Date:
            {{ moment(generatedReport.start_date).format("MM/DD/YYYY") }} - End
            Date: {{ moment(generatedReport.end_date).format("MM/DD/YYYY") }})
          </div>
          <div class="report-container">
            <div class="chart-container">
              <div class="chart">
                <div class="chart-header">Total Points Awarded by Unit</div>
                <div class="graph">
                  <report-graph
                    chartId="chart-1"
                    v-if="
                      generatedReport.pointsAwardedByUnit
                        .pointsAwardedByUnitList
                    "
                    :chartData="
                      generatedReport.pointsAwardedByUnit
                        .pointsAwardedByUnitList
                    "
                    :chartType="'Pie'"
                  ></report-graph>
                </div>
                <div
                  class="chart-data"
                  v-if="
                    generatedReport.pointsAwardedByUnit.pointsAwardedByUnitList
                  "
                >
                  <div
                    class="chart-row"
                    v-for="program in generatedReport.pointsAwardedByUnit
                      .pointsAwardedByUnitList"
                    :key="program.client_id"
                  >
                    <span>{{ program.client_name }}</span>
                    <span>{{ program.points.toLocaleString() }}</span>
                    <span>{{ program.percentage.toFixed(2) }}%</span>
                  </div>
                  <div class="chart-row total">
                    <span>Total Awarded</span>
                    <span>{{
                      generatedReport.pointsAwardedByUnit.pointsTotal.toLocaleString()
                    }}</span>
                    <span
                      >{{
                        generatedReport.pointsAwardedByUnit.percentageTotal.toFixed(
                          2
                        )
                      }}%</span
                    >
                  </div>
                </div>
              </div>
              <div class="chart">
                <div class="chart-header">Total Points Remaining by Unit</div>
                <div class="graph">
                  <report-graph
                    chartId="chart-2"
                    v-if="
                      generatedReport.pointsRemainingByUnit
                        .pointsRemainingByUnitList
                    "
                    :chartData="
                      generatedReport.pointsRemainingByUnit
                        .pointsRemainingByUnitList
                    "
                    :chartType="'Pie'"
                  ></report-graph>
                </div>
                <div
                  class="chart-data"
                  v-if="
                    generatedReport.pointsRemainingByUnit
                      .pointsRemainingByUnitList
                  "
                >
                  <div
                    class="chart-row"
                    v-for="program in generatedReport.pointsRemainingByUnit
                      .pointsRemainingByUnitList"
                    :key="program.client_id"
                  >
                    <span>{{ program.client_name }}</span>
                    <span>{{ program.points.toLocaleString() }}</span>
                    <span>{{ program.percentage.toFixed(2) }}%</span>
                  </div>
                  <div class="chart-row total">
                    <span>Total Remaining</span>
                    <span>{{
                      generatedReport.pointsRemainingByUnit.pointsTotal.toLocaleString()
                    }}</span>
                    <span
                      >{{
                        generatedReport.pointsRemainingByUnit.percentageTotal.toFixed(
                          2
                        )
                      }}%</span
                    >
                  </div>
                </div>
              </div>
              <div class="chart">
                <div class="chart-header">Total Points Redeemed by Unit</div>
                <div class="graph">
                  <report-graph
                    chartId="chart-3"
                    v-if="
                      generatedReport.pointsRedeemedByUnit
                        .pointsRedeemedByUnitList
                    "
                    :chartData="
                      generatedReport.pointsRedeemedByUnit
                        .pointsRedeemedByUnitList
                    "
                  ></report-graph>
                </div>
                <div
                  class="chart-data"
                  v-if="
                    generatedReport.pointsRedeemedByUnit
                      .pointsRedeemedByUnitList
                  "
                >
                  <div
                    class="chart-row"
                    v-for="program in generatedReport.pointsRedeemedByUnit
                      .pointsRedeemedByUnitList"
                    :key="program.client_id"
                  >
                    <span>{{ program.client_name }}</span>
                    <span>{{ program.points.toLocaleString() }}</span>
                    <span>{{ program.percentage.toFixed(2) }}%</span>
                  </div>
                  <div class="chart-row total">
                    <span>Total Redeemed</span>
                    <span>{{
                      generatedReport.pointsRedeemedByUnit.pointsTotal.toLocaleString()
                    }}</span>
                    <span
                      >{{
                        generatedReport.pointsRedeemedByUnit.percentageTotal.toFixed(
                          2
                        )
                      }}%</span
                    >
                  </div>
                </div>
              </div>
              <div class="chart">
                <div class="chart-header">Points Awarded by Program</div>
                <div class="graph">
                  <report-graph
                    chartId="chart-4"
                    v-if="
                      generatedReport.pointsAwardedByProgram
                        .pointsAwardedByProgramList
                    "
                    :chartData="
                      generatedReport.pointsAwardedByProgram
                        .pointsAwardedByProgramList
                    "
                    :labelPropName="'programName'"
                    :dataPropName="'presetPoints'"
                    :showDataLabels="false"
                  ></report-graph>
                </div>
                <div
                  class="chart-data"
                  v-if="
                    generatedReport.pointsAwardedByProgram
                      .pointsAwardedByProgramList
                  "
                >
                  <div
                    class="chart-row"
                    v-for="program in generatedReport.pointsAwardedByProgram
                      .pointsAwardedByProgramList"
                    :key="program.program_id"
                  >
                    <span>{{ program.programName }}</span>
                    <span>{{ program.presetPoints.toLocaleString() }}</span>
                    <span>{{ program.percentage.toFixed(2) }}%</span>
                  </div>
                  <div class="chart-row total">
                    <span>Program Total</span>
                    <span>{{
                      generatedReport.pointsAwardedByProgram.pointsTotal.toLocaleString()
                    }}</span>
                    <span
                      >{{
                        generatedReport.pointsAwardedByProgram.percentageTotal.toFixed(
                          2
                        )
                      }}%</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-spin>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ReportGraph from "./ReportGraph.vue";
export default {
  name: "P4pReport",
  components: { ReportGraph },
  data() {
    return {};
  },
  methods: {},
  computed: {
    authorizedClients() {
      return this.$store.getters["p4pDashboard/getAuthorizedClients"];
    },
    status() {
      return this.$store.getters["p4pDashboard/getStatus"];
    },
    generatedReport() {
      return this.$store.getters["p4pDashboard/getGeneratedReport"];
    },
  },
};
</script>

<style lang="scss" scoped>
.border {
  border-radius: 5px;
}

.page-heading {
  font-size: 20px;
  font-weight: 500;
}
.report-header {
  text-align: center;
  font-size: 1.5em;
  font-weight: 700;
}
.chart-container {
  display: flex;
  flex-wrap: wrap;
  .chart {
    flex-basis: 42%;
    min-height: 400px;
    margin: 2% 4%;
    .chart-header {
      text-align: center;
      font-size: 1.2em;
      font-weight: 500;
    }
    .graph {
      min-height: 300px;
      min-width: 300px;
      & > div {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
      }
    }
    .chart-data {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-height: 320px;
      overflow-y: auto;
      .chart-row {
        display: flex;
        width: 80%;
        justify-content: space-between;
        padding: 2% 0%;
        border-bottom: 0.5px solid #f2f2f2;
        &.total {
          font-weight: 500;
        }
        span:nth-child(1) {
          flex-basis: 50%;
        }
      }
    }
  }
}
</style>
